/* Shared helpers for feature panels */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useChannels(guildId, botPresent) {
  const [channels, setChannels] = useState([]);
  useEffect(() => {
    if (!guildId || !botPresent) return;
    api.get(`/bot/channels?guild_id=${guildId}`).then((r) => setChannels(r.data)).catch(() => {});
  }, [guildId, botPresent]);
  return channels;
}

export function useRoles(guildId, botPresent) {
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    if (!guildId || !botPresent) return;
    api.get(`/features/roles/${guildId}`).then((r) => setRoles(r.data)).catch(() => {});
  }, [guildId, botPresent]);
  return roles;
}
